import css from "./MdContent.module.css";
import { Root } from "node_modules/remark-parse/lib";
import { GameVer, useT } from "~/util/Lang";
import {
  collectHeadings,
  MDDat,
  renderMarkdown,
} from "~/util/MarkdownRenderer";
import { Heading3 } from "../ui/Heading";
import { Link } from "react-router";

export function MdContent(props: {
  children: { root: Root; dat: MDDat; gver: GameVer };
}) {
  const toc = collectHeadings(props.children.root);
  return (
    <div className={css.root}>
      <TableOfContents items={toc} />
      {renderMarkdown(props.children)}
    </div>
  );
}

interface TOCProps {
  items: { depth: number; text: string; id: string }[];
}

export const TableOfContents: React.FC<TOCProps> = ({ items }) => {
  if (!items.length) return null;
  const t = useT();
  return (
    <nav aria-label="Оглавление" style={{ margin: "20px 0" }}>
      <Heading3>{t({ en: "Contents", ru: "Содержание" })}</Heading3>
      <ul style={{ listStyle: "none", paddingLeft: "1rem" }}>
        {items.map((item, index) => (
          <li key={index} style={{ marginLeft: `${(item.depth - 2) * 1}rem` }}>
            <Link to={{ hash: `#${item.id}` }}>{item.text}</Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};
